import type { IconData } from '@stacksjs/iconify-core'

export const healthMedicalNotes: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.425 29.72h1.53V5.33h-1.53V3.81h-6.09V2.29h-3.05v1.52h1.52v1.52H12.2V3.81h1.52V2.29h-3.05v1.52H4.575v1.52h-1.53v24.39h1.53v1.52h22.85Zm-1.52-1.53H6.1V5.33h4.57v1.53h10.67V5.33h4.57Z\"/><path fill=\"currentColor\" d=\"M12.195 25.14h10.66v1.53h-10.66Zm0-4.57h10.66v1.53h-10.66Zm4.57-9.14h6.09v1.52h-6.09ZM13.715.76h4.57v1.53h-4.57ZM12.195 16h10.66v1.53h-10.66Zm-3.05 9.14h1.52v1.53h-1.52Zm0-4.57h1.52v1.53h-1.52Zm0-4.57h1.52v1.53h-1.52Zm0-1.52h3.05v-1.53h1.52V9.91h-1.52V8.38h-3.05v1.53h-1.53v3.04h1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default healthMedicalNotes
